export const TEAM_LEADER = "Chef d'équipe";
